import _ from 'lodash';
import { createClient } from '@/shared/api';
import type {
  StudyInfoClinicWebViewQuery,
  StudyInfoClinicWebViewQueryVariables,
} from '@/shared/api';
import STUDY_INFO_CLINIC_WEB_VIEW_QUERY from '../queries/studyInfoClinicWebView';

/**
 * Loads the clinic study information trimmed for the embedded web view. Runs STUDY_INFO_CLINIC_WEB_VIEW_QUERY and throws the first GraphQL error message when the study field is nil.
 *
 * @param id - Identifier of the study to load.
 * @returns The clinic study information for the web view.
 */
const fetchStudyInfoClinicWebView = async (id: any) => {
  const client = createClient();
  const studyInforesult = await client.query<
    StudyInfoClinicWebViewQuery,
    StudyInfoClinicWebViewQueryVariables
  >({
    query: STUDY_INFO_CLINIC_WEB_VIEW_QUERY,
    variables: {
      id,
    },
  });
  const { data, errors } = studyInforesult;
  const { study: studyInfo } = data;
  if (_.isNil(studyInfo) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return studyInfo;
};

export default fetchStudyInfoClinicWebView;
